import React, { FunctionComponent, useState, useEffect } from "react";

import * as MarketingApi from "../../../api/marketingApi";
import { EmailTemplate } from "../../../models/Marketing";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { isOk } from "../../../result";

interface EmailTemplateSelectProps extends Omit<SelectProps, "loading"> {
  updatedSinceDaysBack?: number;
  label?: string;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
  onSelected: (item: EmailTemplate) => void;
  additionalTemplates: Array<EmailTemplate>;
}

export const EmailTemplateSelect: FunctionComponent<EmailTemplateSelectProps> = ({
  label = "Email template type",
  required = false,
  disabled = false,
  onSelected,
  onChange,
  variant = "standard",
  value = "",
  error = false,
  additionalTemplates = [],
  updatedSinceDaysBack,
  ...props
}) => {
  const [state, setState] = useState<ReadonlyArray<EmailTemplate>>([]);

  useEffect(() => {
    MarketingApi.getEmailTemplates(updatedSinceDaysBack).then(result => {
      if (isOk(result)) {
        return setState(result.value);
      }

      return setState([]);
    });
  }, []);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let item = state.find(c => c.id === event.target.value);
      if (item) {
        onSelected(item);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  return (
    <FormControl
      variant={variant}
      className={props.className}
      error={error}
      required={required}
      disabled={disabled}
    >
      <InputLabel
        id="email-template-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="email-template-select-label"
        id="email-template-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state
            .concat(
              additionalTemplates.filter(et => !state.find(x => x.id === et.id))
            )
            .map(x => (
              <MenuItem key={x.id} value={x.id}>
                {x.description}
              </MenuItem>
            ))}
      </Select>
      {updatedSinceDaysBack && updatedSinceDaysBack > 0 && (
        <FormHelperText>
          Showing templates updated the last {updatedSinceDaysBack} days
        </FormHelperText>
      )}
    </FormControl>
  );
};
